import {  Button, Row, Col, Card } from "react-bootstrap";
import { createRole } from "../../../../services/RoleService";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const validationSchema = Yup.object().shape({
  label: Yup.string().required("Required"),
  number: Yup.string().required("Required"),
  slug: Yup.string().required("Required"),

});

const AddRoleForm = () => {
  const initialValues = {
  label: "",
  number: '',
  slug:"",
  };

  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    // Send the form data to the server
    try {
      await createRole(values);
      // Show success toast notification
      toast.success("Role added Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/roles");
      }, 3000);
      console.log("Role added successfully");
      
      // Optionally, redirect or update state after successful add
    } catch (error) {
      console.error("Error adding role:", error);
      toast.error("Failed to adding Project Code!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col md={12}>
              <h4>Add Role Details</h4>
              <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({errors,touched,isSubmitting})=>(
              <Form id="userUpdateForm">
                <Row className="mt-3 mb-3">
                  <Col md={3}>
                    <div controlId="label">
                      <label>Label</label>
                      <Field
                        type="text"
                        name="label"
                        className="form-control"
                        placeholder="Label"
                      />
                      {errors.label && touched.label && (
                      <div className="text-danger">{errors.label}</div>
                    )}
                    </div>
                  </Col>
                  <Col md={3}>
                    <div controlId="number">
                      <label>Number</label>
                      <Field
                        type="text"
                        name="number"
                        className="form-control"
                        placeholder="Number"
                      />
                      {errors.number && touched.number && (
                      <div className="text-danger">{errors.number}</div>
                    )}
                    </div>
                  </Col>
                  <Col md={3}>
                    <div controlId="slug">
                      <label>Slug</label>
                      <Field
                        type="text"
                        name="slug"
                        className="form-control"
                        placeholder="slug"
                      />
                      {errors.slug && touched.slug && (
                      <div className="text-danger">{errors.slug}</div>
                    )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Button
                      style={{ background: "#3a7afe" }}
                      variant="primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      <i className="ti-save-alt" /> Save
                    </Button>
                    <Button
                      style={{
                        background: "#f25767",
                        border: "0px",
                        margin: "0.5rem",
                      }}
                      variant="warning"
                      href="/settings/roles"
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  </Col>
                  
                </Row>
              </Form>
              )}
              </Formik>
            </Col>
            
          </Row>
        </div>
        <ToastContainer />
      </Card>
     
      
    </>
  );
};

export default AddRoleForm;
